// extracted by mini-css-extract-plugin
export default {"title":"title_title__GBY0+","switch":"title_switch__CRA3P"};